/**
 * Formatea un número con separador de miles.
 * @param {number|string} value - Número a formatear.
 * @param {string} locale - Configuración local, por defecto 'de-DE' (1.000,00).
 * @param {number} minFractionDigits - Cantidad mínima de decimales.
 * @returns {string} Número formateado o string vacío si no es válido.
 */
export function formatNumber(value, locale = "de-DE", minFractionDigits = 0) {
  if (value === null || value === undefined || value === "") return "";
  const num = Number(value);
  if (isNaN(num)) return value;
  return num.toLocaleString(locale, { minimumFractionDigits: minFractionDigits });
}
